import { ChainId } from 'pancake-sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x1Ee38d535d541c55C9dae27B12edf090C608E6Fb', // TODO
  [ChainId.TESTNET]: '0x301907b5835a2d723Fe3e9E8C5Bc5375d5c1236A',
  [ChainId.ARBITRUM]: '0x842eC2c7D803033Edf55E478F461FC547Bc54EB2',
  [ChainId.OKX]: '0x370aD3199b09c593f94d27abBcC9aa6022CC165b',
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
